<template>
  <div>
      <ServerError v-if="ServerError"/>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout wrap py-5 py-lg-5 pl-md-4>
          <v-flex xs12 md4>
            <div class="RM clr">SELLER PORTAL</div>
            <div class="head">Products Sold</div>
          </v-flex>
          <v-flex md3 >
            <v-layout wrap>
              <v-flex xs6>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      class="textfd"
                      dense
                      v-model="date"
                      label="Search by Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-btn
                @click="getData"
                  height="40px"
                  tile
                  width="100%"
                  color="#FEBD08"
                  elevation="0"
                >
                  Search
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pt-5>
            <!-- <span style="color: #d39c00"> Today, 05 JUL, 2021</span> -->
          </v-flex>
          <v-flex xs12 pt-5 >
            <v-layout wrap>
              <v-flex v-if="soldproducts.length < 1 " >
              <span class="RB">   No result Found....</span>
              </v-flex>
            </v-layout>
            <v-layout wrap v-for="(item, i) in soldproducts" :key="i">
              <v-flex xs12 pb-4>
                <span class="RM">Order  #{{item.orderID}} </span>
                <span style="margin-left: 3%" class="RM"> {{item.products.length}} Product </span>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex sm6 md4 lg3 xl2 py-2 v-for="(details, i) in item.products" :key="i" >
                    <v-card flat >
                      <v-layout wrap @click=" goTo(item._id)" style="cursor:pointer" >
                        <v-flex xs3  sm3>
                          <v-img
                            height="80px"
                            width="80px"
                            :src="mediaURL +details.productId.photos[0]"
                          >
                          </v-img>
                        </v-flex>
                        <v-flex xs9 pl-1 pl-lg-3>
                          <v-layout wrap fill-height>
                            <v-flex xs12 class="RM clr">{{details.name}} </v-flex>
                            <v-flex xs6 sm4 md6 class="regulartext"
                              >Price: ₹{{details.productTotalAmount}}
                            </v-flex>
                            <v-flex xs4 md4 class="regulartext">{{details.quantity}} kg </v-flex>
                            <v-flex
                              xs12
                              align-self-end
                              class="regulartext"
                              style="color: #42af54; font-size: 12px"
                              >
                              {{details.productOrderStatus}}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-5><v-divider> </v-divider></v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
             
            </v-layout>
          </v-flex>
        </v-layout>
    
  </div>
</template>
<script>
import axios from "axios"
export default {
  data()
  {
    return{
      ServerError:false,
      appLoading:false,
    date:"",
     menu:"",

      soldproducts:[]

    }
  },
 
  mounted()
  {
 this.getData();
  },
  methods:{
    goTo(value)
    {
    this.$router.push({
        path: "/productSoldDetails",
        query: {
          productId: value,
        },
      });
    },
    getData()
    {
      this.appLoading =true;
      axios({
        method: "post",
        url: "/seller/order/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
       data:{
          date:this.date
        }
      })
      .then((response) =>{
        if(response.data.status)
        {
               this.soldproducts = response.data.data
               console.log(this.soldproducts)
        }
        this.appLoading =false;

      })
       .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    }
  }
}
</script>